# custom directive to remove the extra DOM node that ng-include adds
# credit: http://stackoverflow.com/questions/17589358/avoid-using-extra-dom-nodes-when-using-nginclude
window.globalHelpersModule.directive 'includeReplace', ->
  require: '^ngInclude'
  restrict: 'A'
  link: (scope, el, attrs) ->
    el.replaceWith el.children()
    return